import { c as _c } from "react-compiler-runtime";
import React from "react";
import { Group, Label, Text } from "react-aria-components";
import { Avatar } from "./Avatar.js";
import { ProgressBar } from "./ProgressBar.js";
import { baseChip, detailTag, nameGroup, nameText, positionTitle, thumbnail, titleIcon } from "./SimilarProfileChip.css.js";
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
const BaseSimilarProfileChip = (t0, ref) => {
  const $ = _c(32);
  const {
    name,
    title,
    imageSrc,
    roleMatch,
    roleLabel,
    skillLabel,
    skillMatch,
    titleIcon: Icon
  } = t0;
  const hasSkill = skillLabel !== undefined && skillMatch !== undefined;
  const hasRole = roleLabel !== undefined && roleMatch !== undefined;
  const t1 = !(hasSkill || hasRole);
  let t2;
  if ($[0] !== t1) {
    t2 = baseChip({
      noScale: t1
    });
    $[0] = t1;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  let t3;
  if ($[2] !== imageSrc || $[3] !== name) {
    t3 = /*#__PURE__*/_jsx("span", {
      className: thumbnail,
      children: /*#__PURE__*/_jsx(Avatar, {
        tooltip: false,
        src: imageSrc,
        size: "m",
        name: name
      })
    });
    $[2] = imageSrc;
    $[3] = name;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  let t4;
  if ($[5] !== name) {
    t4 = /*#__PURE__*/_jsx(Text, {
      className: nameText,
      children: name
    });
    $[5] = name;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  let t5;
  if ($[7] !== Icon) {
    t5 = Icon && /*#__PURE__*/_jsx(Icon, {
      className: titleIcon
    });
    $[7] = Icon;
    $[8] = t5;
  } else {
    t5 = $[8];
  }
  let t6;
  if ($[9] !== t4 || $[10] !== t5) {
    t6 = /*#__PURE__*/_jsxs(Group, {
      className: nameGroup,
      children: [t4, t5]
    });
    $[9] = t4;
    $[10] = t5;
    $[11] = t6;
  } else {
    t6 = $[11];
  }
  let t7;
  if ($[12] !== title) {
    t7 = /*#__PURE__*/_jsx(Text, {
      className: positionTitle,
      children: title
    });
    $[12] = title;
    $[13] = t7;
  } else {
    t7 = $[13];
  }
  let t8;
  if ($[14] !== hasSkill || $[15] !== roleLabel || $[16] !== roleMatch || $[17] !== skillLabel || $[18] !== skillMatch) {
    t8 = hasSkill && /*#__PURE__*/_jsxs(_Fragment, {
      children: [/*#__PURE__*/_jsx(Label, {
        className: detailTag({
          bottomLabel: roleLabel === undefined,
          topLabel: roleLabel !== undefined
        }),
        children: skillLabel
      }), /*#__PURE__*/_jsx("span", {
        className: detailTag({
          bottomScale: roleMatch === undefined,
          topScale: roleMatch !== undefined
        }),
        children: /*#__PURE__*/_jsx(ProgressBar, {
          type: "dots",
          value: skillMatch,
          dots: 5,
          "aria-label": "Similar profile skill match score"
        })
      })]
    });
    $[14] = hasSkill;
    $[15] = roleLabel;
    $[16] = roleMatch;
    $[17] = skillLabel;
    $[18] = skillMatch;
    $[19] = t8;
  } else {
    t8 = $[19];
  }
  let t9;
  if ($[20] !== hasRole || $[21] !== roleLabel || $[22] !== roleMatch) {
    t9 = hasRole && /*#__PURE__*/_jsxs(_Fragment, {
      children: [/*#__PURE__*/_jsx(Label, {
        className: detailTag({
          bottomLabel: true
        }),
        children: roleLabel
      }), /*#__PURE__*/_jsx("span", {
        className: detailTag({
          bottomScale: true
        }),
        children: /*#__PURE__*/_jsx(ProgressBar, {
          type: "dots",
          value: roleMatch,
          dots: 5,
          "aria-label": "Similar profile role match score"
        })
      })]
    });
    $[20] = hasRole;
    $[21] = roleLabel;
    $[22] = roleMatch;
    $[23] = t9;
  } else {
    t9 = $[23];
  }
  let t10;
  if ($[24] !== ref || $[25] !== t2 || $[26] !== t3 || $[27] !== t6 || $[28] !== t7 || $[29] !== t8 || $[30] !== t9) {
    t10 = /*#__PURE__*/_jsxs(Group, {
      ref: ref,
      className: t2,
      children: [t3, t6, t7, t8, t9]
    });
    $[24] = ref;
    $[25] = t2;
    $[26] = t3;
    $[27] = t6;
    $[28] = t7;
    $[29] = t8;
    $[30] = t9;
    $[31] = t10;
  } else {
    t10 = $[31];
  }
  return t10;
};
export const SimilarProfileChip = /*#__PURE__*/React.forwardRef(BaseSimilarProfileChip);
//# sourceMappingURL=SimilarProfileChip.js.map